import * as types from './actionTypes'

export function toggleRemarkScreen() {
  return { type: types.TOGGLE_REMARK_SCREEN }
};


// WEBPACK FOOTER //
// ./src/state/actions.js